<template>
  <div :class="dinamicClass">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{heading:string | number}>(), {
  heading: '1',
});
const dinamicClass = computed(() => ({
  [`heading-${props.heading}`]: props.heading,
}));
</script>

<style scoped>
  .heading-1{
    font-size: 12px;
  }
  .heading-2{
    font-size: 14px;
  }
  .heading-3{
    font-size: 16px;
  }
  .heading-4{
    font-size: 18px;
  }
  .heading-5{
    font-size: 20px;
  }
  .heading-6{
    font-size: 24px;
  }
</style>
